import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useFeatureToggles, useIntl } from '@grandvisionhq/state';
import { generateVirtualAppointmentStoreData, generateVirtualAppointmentStoreByIdData } from '../utils.js';

const useVirtualAppointment = ()=>{
    const { featureConfigs  } = useFeatureToggles();
    const { appointmentBookingVirtualAppointmentTypeId , appointmentBookingVirtualAppointmentStoreCode ,  } = featureConfigs !== null && featureConfigs !== void 0 ? featureConfigs : {};
    const appointmentBookingVirtualAppointmentGlobalStoreId = String(appointmentBookingVirtualAppointmentStoreCode);
    const { getLabel  } = useIntl();
    const enabled = appointmentBookingVirtualAppointmentTypeId !== undefined && appointmentBookingVirtualAppointmentStoreCode !== undefined;
    /**
   * @deprecated // isVirtualAppointmentStore is deprecated, please use "isVirtualAppointmentStoreById". TODO: MACC-19077 remove before merging to master
   */ const isVirtualAppointmentStore = React.useCallback((store)=>store ? String(store.code) === appointmentBookingVirtualAppointmentStoreCode : false
    , [
        appointmentBookingVirtualAppointmentStoreCode
    ]);
    const isVirtualAppointmentStoreById = React.useCallback((store)=>store ? store.globalStoreId === appointmentBookingVirtualAppointmentGlobalStoreId : false
    , [
        appointmentBookingVirtualAppointmentGlobalStoreId
    ]);
    const isVirtualAppointmentType = React.useCallback((type)=>type ? type.id === appointmentBookingVirtualAppointmentTypeId : false
    , [
        appointmentBookingVirtualAppointmentTypeId
    ]);
    /**
   * @deprecated // getStoreData is deprecated, please use "getStoreByIdData". TODO: MACC-19077 remove before merging to master
   */ const getStoreData = React.useCallback((store, type)=>{
        if (appointmentBookingVirtualAppointmentStoreCode === undefined || !type) {
            return null;
        }
        return store ? swcHelpers.objectSpread({}, store, {
            appointmentTypes: [
                type
            ]
        }) : generateVirtualAppointmentStoreData(Number(appointmentBookingVirtualAppointmentStoreCode), type);
    }, [
        appointmentBookingVirtualAppointmentStoreCode
    ]);
    const getStoreByIdData = React.useCallback((store, type)=>{
        if (appointmentBookingVirtualAppointmentGlobalStoreId === undefined || !type) {
            return null;
        }
        return store ? swcHelpers.objectSpread({}, store, {
            appointmentTypes: [
                type
            ]
        }) : generateVirtualAppointmentStoreByIdData(appointmentBookingVirtualAppointmentGlobalStoreId, type);
    }, [
        appointmentBookingVirtualAppointmentGlobalStoreId
    ]);
    const getAppointmentTypeData = React.useCallback((type)=>{
        if (appointmentBookingVirtualAppointmentTypeId === undefined) {
            return null;
        }
        var ref, ref1;
        return swcHelpers.objectSpread({}, type, {
            id: appointmentBookingVirtualAppointmentTypeId,
            name: getLabel('appointments.virtualAppointment.name'),
            description: getLabel('appointments.virtualAppointment.description'),
            ageGroup: 'ADULT',
            duration: (ref = type === null || type === void 0 ? void 0 : type.duration) !== null && ref !== void 0 ? ref : {
                amount: 0,
                unit: 'MINUTES'
            },
            isVisibleToCustomers: (ref1 = type === null || type === void 0 ? void 0 : type.isVisibleToCustomers) !== null && ref1 !== void 0 ? ref1 : false
        });
    }, [
        appointmentBookingVirtualAppointmentTypeId,
        getLabel
    ]);
    return React.useMemo(()=>[
            {
                isVirtualAppointmentStore,
                isVirtualAppointmentStoreById,
                isVirtualAppointmentType,
                getStoreData,
                getStoreByIdData,
                getAppointmentTypeData
            },
            {
                enabled,
                globalStoreId: appointmentBookingVirtualAppointmentGlobalStoreId,
                typeId: appointmentBookingVirtualAppointmentTypeId
            }, 
        ]
    , [
        isVirtualAppointmentStore,
        isVirtualAppointmentStoreById,
        isVirtualAppointmentType,
        getStoreData,
        getStoreByIdData,
        getAppointmentTypeData,
        enabled,
        appointmentBookingVirtualAppointmentGlobalStoreId,
        appointmentBookingVirtualAppointmentTypeId, 
    ]);
};

export { useVirtualAppointment as default, useVirtualAppointment };
//# sourceMappingURL=use-virtual-appointment.js.map
